import { apiRequest } from './api';

export async function fetchWalletSummary() {
  const response = await apiRequest('/wallet/summary', { method: 'GET', withAuth: true });
  return response?.data ?? null;
}

export async function fetchWalletTransactions(options = {}) {
  const params = new URLSearchParams();
  if (options.page) params.set('page', String(options.page));
  if (options.limit) params.set('limit', String(options.limit));
  const q = params.toString();
  const response = await apiRequest(`/wallet/transactions${q ? `?${q}` : ''}`, {
    method: 'GET',
    withAuth: true,
  });
  return response?.data ?? { items: [], pagination: {} };
}

export async function createWalletWithdrawal(payload) {
  const response = await apiRequest('/wallet/withdrawals', {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response?.data ?? null;
}

export async function fetchWalletWithdrawals(options = {}) {
  const params = new URLSearchParams();
  if (options.page) params.set('page', String(options.page));
  if (options.limit) params.set('limit', String(options.limit));
  const q = params.toString();
  const response = await apiRequest(`/wallet/withdrawals${q ? `?${q}` : ''}`, {
    method: 'GET',
    withAuth: true,
  });
  return response?.data ?? { items: [], pagination: {} };
}

export async function fetchWalletDashboard() {
  const response = await apiRequest('/wallet/dashboard', { method: 'GET', withAuth: true });
  return response?.data ?? null;
}

export async function fetchWalletPaymentPreview(montant) {
  const response = await apiRequest(`/wallet/payment-preview?montant=${encodeURIComponent(montant)}`, {
    method: 'GET',
    withAuth: true,
  });
  return response?.data ?? null;
}

export async function createWalletRecharge(payload) {
  const response = await apiRequest('/wallet/recharges', {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response?.data ?? null;
}

export async function transferWalletBalance({ destinataireCodeParrainage, montant }) {
  const response = await apiRequest('/wallet/transfer', {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify({
      destinataireCodeParrainage: String(destinataireCodeParrainage ?? '').trim().toUpperCase(),
      montant: Number(montant),
    }),
  });
  return response;
}

export async function fetchAdminWalletOverview() {
  const response = await apiRequest('/admin/wallet/overview', { method: 'GET', withAuth: true });
  return response?.data ?? null;
}

export async function grantAcademicWalletCredit({ codeParrainage, montant, motif }) {
  const response = await apiRequest('/admin/wallet/credit-academique', {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify({
      codeParrainage: String(codeParrainage ?? '')
        .trim()
        .toUpperCase(),
      montant: Number(montant),
      motif,
    }),
  });
  return response;
}

export async function fetchAdminAcademiaWalletWithdrawals(options = {}) {
  const params = new URLSearchParams();
  if (options.status) params.set('status', String(options.status));
  if (options.page) params.set('page', String(options.page));
  if (options.limit) params.set('limit', String(options.limit));
  const q = params.toString();
  const response = await apiRequest(`/admin/wallet/retraits${q ? `?${q}` : ''}`, {
    method: 'GET',
    withAuth: true,
  });
  const items = Array.isArray(response?.data) ? response.data : [];
  const pagination =
    response?.pagination && typeof response.pagination === 'object'
      ? response.pagination
      : { page: 1, limit: items.length || 1, total: items.length, totalPages: 1 };
  return { items, pagination };
}

export async function updateAdminAcademiaWalletWithdrawalStatus(withdrawalId, statut) {
  const response = await apiRequest(`/admin/wallet/retraits/${encodeURIComponent(withdrawalId)}/statut`, {
    method: 'PATCH',
    withAuth: true,
    body: JSON.stringify({ statut }),
  });
  if (response?.success === false) {
    throw new Error(
      typeof response?.message === 'string' && response.message.trim()
        ? response.message
        : 'Impossible de mettre à jour le retrait.',
    );
  }
  return response;
}

export async function fetchAdminAcademiaWithdrawalConfirmationStatus(withdrawalId) {
  const response = await apiRequest(
    `/admin/wallet/retraits/${encodeURIComponent(withdrawalId)}/confirmation-status`,
    {
      method: 'GET',
      withAuth: true,
    },
  );
  return response?.data ?? null;
}

export async function expireAdminAcademiaWithdrawalPayout(withdrawalId) {
  const response = await apiRequest(
    `/admin/wallet/retraits/${encodeURIComponent(withdrawalId)}/payout-timeout`,
    {
      method: 'POST',
      withAuth: true,
      body: JSON.stringify({}),
    },
  );
  return response;
}
